// extracted by css-extract-rspack-plugin
export default {"icons":"_22DaOAx8OgP1aSL","description":"Othm7Xk1J68KhWtZ","iconGroup":"MtVBrcnug0lQBy8H","dialog":"f1dR5lxrCX4S81_O","header":"cfnRj2KND6si2ZHY","body":"o9zTmwy_oRY2LajY"};